import React from 'react'
import { AdvisorDetailProps, Advisor as AdvisorType } from '../../utils/types'
import { trackEvent } from '../../utils/tracking/mixpanel'
import { useMatchScreen } from '../../context/MatchScreenContext'
import '../../styles/Advisors/AdvisorDetail.scss'
import '../../styles/Advisors/DirectAdvisor.scss'
import ExternalLinkIcon from '../../utils/Icons/ExternalLinkIcon'

interface Props extends AdvisorDetailProps {
    className?: string
    advisor: AdvisorType
    position?: number
}

const AdvisorDetail = ({ title, value, link, isEmail, isPhone, isExternal, className, advisor, position }: Props) => {
  const { state: { pageKey } } = useMatchScreen()
  let content = value

  const getAdvisorType = (format: string): string => {
    switch (format) {
      case 'network':
        return 'Advisor Network'
      case 'firm':
        return 'Enterprise Advisor'
      case 'human':
        return 'Direct Advisor'
      default:
        return format
    }
  }

  const handleEmailClick = () => {
    if (isEmail && advisor && position !== undefined) {
      trackEvent('MatchScreen', 'falc-handoff-email-click', {
        advisorname: advisor.name,
        position,
        'Advisor Type': getAdvisorType(advisor.format),
        page_key: pageKey
      })
    }
  }

  const handlePhoneClick = () => {
    if (isPhone && advisor && position !== undefined) {
      trackEvent('MatchScreen', 'handoff-advisor-phone-click', {
        advisorname: advisor.name,
        position,
        'Advisor Type': getAdvisorType(advisor.format),
        page_key: pageKey
      })
    }
  }

  if (link) {
    if (isEmail) {
      content = <a href={`mailto:${link}`} onClick={handleEmailClick}>{value}</a>
    } else if (isPhone) {
      content = <a href={`tel:${link}`} onClick={handlePhoneClick}>{value}</a>
    } else if (isExternal) {
      content = <a target='_blank' rel='noopener noreferrer' href={link}>
        {value} <ExternalLinkIcon />
      </a>
    } else {
      content = <a href={link}>{value}</a>
    }
  }

  return (
        <div className={`${className || ''}`}>
            <span className={'stat_title'}>{title}</span>
            <span className={'stat_value'}>{content}</span>
        </div>
  )
}

export default AdvisorDetail
